<template>
    <div class="bind-new-door">
        <EditDialog title="新建出入口" width="500px" :show="visible">
            <el-form size="mini" ref="form" :model="form" label-width="80px" :rules="rules">
                <el-form-item label="名称：" prop="DoorName">
                    <el-input v-model="form.DoorName"></el-input>
                </el-form-item>
                <el-form-item label="编码：" prop="DoorCode">
                    <el-input v-model="form.DoorCode"></el-input>
                </el-form-item>
                <el-form-item label="方向：" prop="Direction" class="is-required">
                    <el-select v-model="form.Direction">
                        <el-option label="正向" :value="1"></el-option>
                        <el-option label="反向" :value="0"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <template #button>
                <div class="dialog-footer">
                    <el-button size="mini" type="primary" @click="handleSave">保存</el-button>
                    <el-button size="mini" @click="handleCancel">取消</el-button>
                </div>
            </template>
        </EditDialog>
    </div>
</template>

<script>
export default {
    name: "BandNewDoor",
    props: {
        visible: {
            type: Boolean,
        },
        entityId: {
            required: true,
            type: String,
        },
    },
    components: {},
    computed: {},
    data() {
        return {
            form: {
                DoorCode: "",
                DoorName: "",
                Direction: 1,
                Memo: "",
                EntityID: "",
            },
            selectData: [],
            rules: {
                DoorCode: [{ required: true, message: "必填项", trigger: "blur" }],
                DoorName: [{ required: true, message: "必填项", trigger: "blur" }],
            },
        };
    },
    methods: {
        handleSave() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    let url = this.$route.query.tid ? "/Tenant/BindNewDoor?tid=" + this.$route.query.tid : "/Entity/BindNewDoor";
                    this.form.EntityID = this.entityId;
                    this.$ajax
                        .post(url, this.form)
                        .then((res) => {
                            this.$message.success("操作成功!");
                            this.$emit("refresh", true);
                            this.handleCancel();
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            });
        },
        handleCancel() {
            this.form = {
                DoorCode: "",
                DoorName: "",
                Direction: 1,
                Memo: "",
            };
            this.$emit("update:visible", false);
        },
    },
};
</script>

<style scoped>
.bind-new-door .dialog-footer {
    text-align: center;
}
</style>
